import { ChangeEvent, useCallback, useEffect, useState } from 'react'

import { GMapInputProps } from './GMapInput';
import { gMapsAddressHandler } from '../../utils/functions/gMapsAddressHandler';
import { AddressInterface, CityInterface } from '../../types/types';

export const useGMapInput = <T extends { city: CityInterface; address: AddressInterface }>(
  fieldName: 'city' | 'address',
  setData: GMapInputProps<T>['setData'], // (inputData: T) => void
  data: GMapInputProps<T>['data'], // T
) => {
  const [autocomplete] = useState<{ value: google.maps.places.Autocomplete | {} }>({ value: {} })

  const onPlaceChanged = useCallback(
    (e: Event) => {
      var place =
        autocomplete.value instanceof google.maps.places.Autocomplete &&
        autocomplete.value.getPlace()
      if (place && place.geometry && place.geometry.location && place.address_components) {
        let tempData = { ...data }
        tempData[fieldName].value = gMapsAddressHandler(fieldName, place).text
        tempData[fieldName].latitude = place.geometry.location.lat().toString()
        tempData[fieldName].longitude = place.geometry.location.lng().toString()
        tempData[fieldName].isDirty = true

        if (fieldName === 'address' && place.address_components) {
          tempData.city.value = gMapsAddressHandler('city', place).text
        }
        setData(tempData)
      }
    },
    [data, autocomplete.value, setData, fieldName],
  )

  const initAutocomplete = useCallback(
    (id: string, value?: string) => {
      const htmlEl: HTMLInputElement | HTMLElement | null = document.getElementById(id)
      //@ts-ignore
      if (htmlEl && value) htmlEl.value = value
      if (htmlEl && htmlEl instanceof HTMLInputElement)
        autocomplete.value = new google.maps.places.Autocomplete(htmlEl, {
          bounds: undefined,
          types: fieldName === 'city' ? ['locality'] : ['geocode'],
          componentRestrictions: { country: [`RU`] },
          fields: ['geometry', 'address_components'],
        })

      if (autocomplete.value instanceof google.maps.places.Autocomplete)
        autocomplete.value.addListener('place_changed', onPlaceChanged)

      //@ts-ignore
      if (htmlEl && htmlEl.value) {
        htmlEl.blur()
        setTimeout(() => {
          htmlEl.focus()
        }, 100)
      }
    },
    [autocomplete, onPlaceChanged, fieldName],
  )

  useEffect(() => {
    const regex = new RegExp('[0-9]')
    if (
      (fieldName === 'city' &&
        // data[index][fieldName].value.length > 0 &&
        Object.keys(autocomplete.value).length === 0) ||
      (fieldName === 'address' &&
        regex.test(data[fieldName].value) &&
        data[fieldName].value.length > 4 &&
        Object.keys(autocomplete.value).length === 0)
    ) {
      initAutocomplete(`${fieldName}`, data[fieldName].value)
    }
    return () => {
      const htmlEl: HTMLElement | null = document.getElementById(`${fieldName}_`)
      if (htmlEl) htmlEl.removeEventListener('place_changed', onPlaceChanged)
    }
  }, [data, fieldName])

  const dataReset = (e: ChangeEvent<HTMLInputElement>) => {
    let tempData = { ...data }
    tempData[fieldName].value = e.target.value
    tempData[fieldName].latitude = undefined
    tempData[fieldName].longitude = undefined
    tempData[fieldName].isDirty = true
    setData(tempData)
  }



  // useEffect(() => {
  //   autocomplete.value = {}
  // }, [data[index].sequence])

  return {
    dataReset,
  }
}
